import { PackageInfo } from '@candulabs/core';
import { VERSION, MODULE_NAME } from './injections';

export const SDK_INFO: PackageInfo = {
  name: MODULE_NAME,
  version: VERSION,
};
